import { QueryClient } from '@tanstack/react-query';

import { useRenameFolder } from '~teacher/hook/useRenameFolder';

interface UseSaveNewFolderParams {
  folderName: string;
  oldName: string;
  renameFolderId: number;
  queryClient: QueryClient;
  onCloseRenameFolder: () => void;
}

export function useSaveNewFolder({
  folderName,
  oldName,
  renameFolderId,
  queryClient,
  onCloseRenameFolder,
}: UseSaveNewFolderParams) {
  const { mutate, isLoading } = useRenameFolder([oldName, folderName]);

  const saveNewFolderName = () =>
    mutate(
      { name: folderName, folderId: renameFolderId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['quiz']);
          onCloseRenameFolder();
        },
      }
    );

  return { saveNewFolderName, isLoading };
}
